import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { TBoardId } from '../../../../../../types/types';
import { groupByEpicsToggle } from '../../../effects/groupByEpicsToggle';

export const onClickGroupByEpicsToggler: ActionCreator<ThunkAction> = (
     boardId: TBoardId
) => {
    const action = (dispatch: Dispatch) => {
        dispatch(groupByEpicsToggle(boardId));
    };
    return action;
};
